<style lang="scss" scoped>
.inbound-info > span {
	display: inline-block;
	width: 33%;
	padding: 6px 0;
}
.inbound-package {
	right: -6px;
	top: -50px;
}
</style>

<template>
	<section class="margin-15 relative">
		<template v-if="type==='query'">
			<span v-if="showbtnpur || detailtype=='manage'">{{$t('fbb.inbound.purchase_order_no', { defaultValue: '采购单号' })}}:{{baseData.poNos}}</span>
			<vButtonGroup class="absolute inbound-package">
                <vButton
					v-if="(status==8 || status == 10)&&baseData.needBox==1&&!isManage&&updateQty"
					theme="error"
					@click="handlePurchase('modifytype')"
				>{{$t('fbb.inbound.modify_plan_no', { defaultValue: '修改产品计划数量' })}}</vButton>
				<vButton
					v-if="poNos!=''"
					theme="info"
					@click="handlePurchaseDetail"
				>{{$t('fbb.inbound.seepurchase',{defaultValue:'查看采购明细'})}}</vButton>
				<vButton
					v-if="status>7&&status<71&&baseData.needBox==1"
					theme="success"
					@click="createPackageLabel"
				>{{$t('fbb.inbound.rawcrates_standard',{defaultValue:'生成箱标'})}}</vButton>
				<vButton
					v-if="status>7&&status<71&&baseData.needBox==1"
					theme="warning"
					@click="downloadPackageLabel"
				>{{$t('fbb.inbound.download_boxlabel',{defaultValue:'下载箱标'})}}</vButton>
				<vButton
					v-if="(status>7&&status<71 ||status==100)&&baseData.needBox==1"
					theme="info"
					@click="handlePackageDetail"
				>{{$t('fbb.inbound.seebox',{defaultValue:'查看装箱'})}}</vButton>
			</vButtonGroup>

		</template>
		<template v-else>
			<vButtonGroup v-if="showbtnpur || detailtype=='manage'" class="margin-bottom-10">
				<vButton theme="success" @click="handlePurchase"
				>{{$t('fbb.inbound.purchase_import',{defaultValue:'从采购单导入'})}}
				</vButton> {{$t('fbb.inbound.purchase_order_no', { defaultValue: '采购单号' })}}:{{poNos}}

                <vButton v-if="type == 'add' && showisToggle" theme="warning" class="pull-right" @click="toggleHandle">切换为手动添加</vButton>
			</vButtonGroup>
			<div v-else>
				<vFormItem label-width="auto" inline label="ERP SKU:">
					<vInput v-model="formData.sku" readonly suffix="search" @on-icon-click="handleSkuErp"></vInput>
				</vFormItem>
				<vFormItem label-width="auto" inline :label="$t('global.common.quantity',{defaultValue:'数量'})">
					<vInputNumber clearable v-model="formData.qty" :min="1" math="round" />
				</vFormItem>
				<vButtonGroup class="inline">
					<vButton
						theme="primary"
						@click="addItem(formData)"
					>{{$t('global.common.add',{defaultValue:'添加'})}}</vButton>
					<vButton
						theme="info"
						@click="handleUploadData"
					>{{$t('global.common.import',{defaultValue:'导入'})}}</vButton>

                    <!-- <vButton v-if="type == 'add'" theme="warning" class="pull-right" @click="toggleHandle">切换为采购单添加</vButton> -->
				</vButtonGroup>
				<vButtonGroup >
					<vButton theme="warning" @click="removeItems">{{$t('global.common.delete',{defaultValue:'删除'})}}</vButton>
					<vButton theme="error" @click="clearAll">{{$tc('global.common.clear',2,{defaultValue:'清空'})}}</vButton>
				</vButtonGroup>
			</div>
		</template>
        <div class="inbound-info" v-if="type!='add'">
            <span>{{$t('fbb.inbound.product_total',{defaultValue:'产品总数量'})}}:{{baseData.planQty}}</span>
            <span>{{$t('fbb.inbound.product_volume',{defaultValue:'产品总体积'})}}(CBM):{{baseData.totalVolume}}</span>
            <span>{{$t('fbb.inbound.product_weight',{defaultValue:'产品总重量'})}}(kg):{{baseData.totalWeight}}</span>
            <template v-if="status>6">
                <span>{{$t('fbb.inbound.total_cases',{defaultValue:'总箱数'})}}:{{baseData.cartonQty}}</span>
                <span>{{$t('fbb.inbound.packing_volume',{defaultValue:'装箱总体积'})}}(CBM):{{baseData.cartonTotalVolume}}</span>
                <span>{{$t('fbb.inbound.packing_weight',{defaultValue:'装箱总重量'})}}(kg):{{baseData.cartonTotalWeight}}</span>
            </template>
        </div>
        <div class="inbound-info" v-else>
            <span>{{$t('fbb.inbound.product_total',{defaultValue:'产品总数量'})}}:{{proData.planQty}}</span>
            <span>{{$t('fbb.inbound.product_volume',{defaultValue:'产品总体积'})}}(CBM):{{proData.totalVolume}}</span>
            <span>{{$t('fbb.inbound.product_weight',{defaultValue:'产品总重量'})}}(kg):{{proData.totalWeight}}</span>
        </div>
		<vTableSimple
			style="max-height:200px;overflow:auto"
			class="margin-top-10"
			:columns="columns"
			:data="dataList"
			@on-check-change="handleCheckData"
		></vTableSimple>
		<compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
			@on-confirm="modalProps.show=false"
		>
			<component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps.props"
				@on-close="modalProps.show=false"
				v-on="modalProps.on"
			/>
		</compModal>
        <compModal
			v-model="operate.show"
			v-bind="operate"
			@on-close="operate.show=false"
			@on-confirm="operate.show=false"
		>
			<component
				v-if="operate.component"
				:is="operate.component"
				v-bind="operate.props"
				@on-close="operate.show=false"
				v-on="operate.on"
			/>
		</compModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>

<script>
import { HttpImportProducts, HttpCreatePackageLabel, HttpDownloadPackageLabel, HttpGetSKUEnName, HttpGetcalculateWeightAndVolume } from '@/service/inbound';
import { HttpShowPurchase } from "@/service/headlogistics";

import compErpsku from './erpsku'
import compPackage from './package'

import compPurchase from './purchase'
import compPurchaseList from './purchaselist'
import comExcel from '@components/templates/excelalert'

export default {
	props: ['data', 'baseData', 'status','PoNos','proinblundList','detailtype','querytype','activeid','isManage'],
	components: {
		compFormEdit: () => import("@components/templates/formedit"),
		compUpload: () => import("@components/templates/upload"),
		compModal: () => import("@components/templates/modal"),
		compErpsku,
		compPackage,
		compPurchase,
		compPurchaseList,
        comExcel
	},
	data() {
		return {
			loading: false,
			type: this.querytype || this.$route.params.type,
			id: this.activeid || this.$route.query.id,
			formData: {},
			dataList: this.data || [],
			poNos:"",
			erpSkuData: {},
			checkedData: [],
			modalProps: {
				show: false,
				formdata: null,
				// title: '导入数据',
				// component: "",
				// props: {},
				// on: {},
			},
			showbtnpur:false,
            inboundPlanOrderPoItemList:[],
            proData:{},
			operate:{
                show: false
			}
		}
	},
	created(){
        this.showisToggle = this.handleAuth('fbb.inboundplan.productImport');
        this.showbtn()
        // 添加权限
		this.updateQty = this.handleAuth('fbb.inboundplan.updateQty');
		// console.log(this.querytype,this.activeid)
	},
	watch: {
        activeid (activeid) {
            if (!activeid) return;
            this.id = activeid;
        },
		data(val) {
			this.dataList = val;
            this.poNos = this.baseData.poNos;
            if(!this.poNos){
                this.showbtnpur = false
            }
		}
	},
	// filters: {
	// 	handleUint(val, base, toFixed) {
	// 		try {
	// 			return parseFloat(val / base).toFixed(toFixed)
	// 		} catch (error) {
	// 			return ''
	// 		}

	// 	}
	// },
	computed: {
		columns() {
			return [{
				type: 'selection',
				formName: 'sku',
				width: this.type === 'query' ? 0 : 60
			}, {
				title: "No.",
				type: 'index'
			}, {
				title: "ERP SKU",
				key: 'sku',
				render(h, { row }) {
					// console.log(row)
					return <div>{row.sku} <span style="color:red;">{row.isNew}</span> </div>
				}
			},{
				title: this.$t('global.common.En_name', { defaultValue: "名称(英文)" }),
                key: this.isManage ? 'productNameEn' : 'skuname',
                width:380,
			}, {
				title: this.$t('fbb.inbound.planned_quantity', { defaultValue: '计划数量' }),
				key: 'qty'
			}, {
				title: this.$t('fbb.inbound.has_usingcontainer', { defaultValue: '已装箱数' }),
				key: 'qtyPacked',
				width: this.status > 7 ? '' : 0
			}, {
				title: this.$t('fbb.inbound.has_receivedno', { defaultValue: '已接收数' }),
				key: 'receivedQty',
				width: this.status > 7 ? '' : 0
			}, {
				title: this.$t('global.common.size', { defaultValue: '尺寸' }) + "(cm*cm*cm)",
				key: "qtyPacked",
				render(h, { row }) {
					// console.log(row)
					return `${row.length}*${row.width}*${row.height}`
				}
			}, {
				title: this.$t('global.common.weight', { defaultValue: '重量' }) + "(g)",
				key: 'weight'
			}]
		}
	},

	methods: {
        toggleHandle(){
            this.modalProps = {
				show: true,
                title: this.$tc('global.common.clear', 1, { defaultValue: '清空所有' }),
                showDesc:true,
                desc:'切换之后将清空采购产品明细，需手动添加产品明细且无法切回！',
				alert: 'warning',
				ajaxRequest: async () => {
                    this.showbtnpur = !this.showbtnpur;
                    this.dataList = [];
                    this.poNos = '';
                    this.proData = {}
                    this.inboundPlanOrderPoItemList = [];
                    this.$emit('on-newdata',this.dataList)
					return { message: this.$t('global.common.haveto_empty', { defaultValue: '已清空' }) };
				}
			}

            // this.$emit('on-newdata',{})
        },
		showbtn(){
			HttpShowPurchase().then(res=>{
				if(res.data == 1){
					this.showbtnpur = true
				}else{
					this.showbtnpur = false
				}
			},err=>{
				this.$VMessage.error(err.message);
			})
		},
		/**
		 * 获取选中产品sku
		 */
		handleCheckData(rows, val) {
			this.checkedData = val;
		},
		// 从采购单导入
		getpurchaseList(data){
			// this.dataList = []
            // this.dataList.push(...data.content)


            this.chargeSkuEnName(data.content)

			this.inboundPlanOrderPoItemList = data.tablelist
            this.poNos = data.orderNo
			this.$emit('on-newdata',data.newData)
        },
        getallVolumnWeight(datatable){
            // 请求总体积总重量
            // console.log(datatable,'datatabledatatable')
            let jsonone = {},allnumber=0;
            datatable.map(item=>{
                allnumber+=item.qty;
                jsonone[item.sku] = item.qty
            })
            this.baseData.planQty = allnumber;
            this.proData.planQty = allnumber;

            HttpGetcalculateWeightAndVolume(jsonone).then(res=>{
                // console.log(res.data)
                this.baseData.totalVolume = res.data.totalVolume.toFixed(4);
                this.$set(this.proData,'totalVolume',res.data.totalVolume.toFixed(4))
                this.baseData.totalWeight = res.data.totalWeight.toFixed(4);
                this.$set(this.proData,'totalWeight',res.data.totalWeight.toFixed(4))
            },err=>{

            })
        },
        // 传到子组件的时候sku英文名已经转化
        chargeSkuEnName(skulist){
            // console.log(skulist,'skulistskulist')
            let skuarr = [];
            skulist.map(item=>{
                skuarr.push(item.productId)
            })
            HttpGetSKUEnName({
                productIds:skuarr
            }).then(res=>{
                skulist.map(item=>{
                    res.data.map(jsonone => {
                        if(item.productId === jsonone.id){
                            item.skuname = jsonone.nameEn + ' (' + jsonone.name + ')'
                        }
                    })
                })
                this.dataList = skulist;
                // console.log(skulist,'skuarrskulistskulistskulistskulist')
                this.getallVolumnWeight(this.dataList)
            })
        },
		// 详情操作
		handlePackageDetail() {
			this.modalProps = {
				show: true,
				title: this.$t('fbb.inbound.seebox_detail', { defaultValue: '查看装箱详情' }),
				width: 1000,
				component: "compPackage",
				showFooter: false,
				props: {
					startUp: true,
					initFormData: {
						id: this.id
					}
				}
			}
		},
		handlePurchaseDetail() {
			this.modalProps = {
				show: true,
				title: this.$t('fbb.inbound.seepurchase', { defaultValue: '查看采购明细' }),
				width: 1000,
				component: "compPurchaseList",
				showFooter: false,
				props: {
					startUp: true,
					initFormData: {
						inboundPlanOrderId: this.id
					}
				}
			}
		},
		//查询ERPSKU
		handleSkuErp() {
			this.modalProps = {
				show: true,
				title: 'SKU',
				component: "compErpsku",
				showFooter: false,
				width: 1000,
				props: {
					// initFormData: {
					// 	"search[EQ_lineId]": this.baseData.lineId == 0 ? '' : this.baseData.lineId
					// }
                    lineId: this.baseData.lineId,
				},
				on: {
					'on-data': (row) => {
						const { id: productId = "", sku = "", length = "", width = "", height = "", weight = "", cost: productCost = "", packingSize = "", chargeSize = "", lineId = "" } = row;
                        this.formData = { qty: this.formData.qty, productId, sku, lineId, length, width, height, weight, productCost, packingSize, chargeSize };
                        this.formData.skuname = row.nameEn + ' (' + row.name + ')'
						this.modalProps.show = false;
					}
				},
			}
		},
		//上传数据
		handleUploadData() {
			this.modalProps = {
				show: true,
				title: this.$t('global.common.import', { defaultValue: '导入数据' }),
				component: "compUpload",
				showFooter: false,
				width: "middle",
				props: {
					ajaxRequest: HttpImportProducts,
					name: "multipartFile",
					download: () => {
						this.handleWebfs("/static/template/inbound_product.xlsx", {}, {
							executor: 'download',
							type: 'url'
						});
					},
				},
				on: {
					'on-success': (row) => {
						Object.values(row.data || []).forEach((item) => {
							this.addItem(item);
                        })
                        this.chargeSkuEnName(Object.values(row.data || []))
						this.modalProps.show = false;
					}
				},
			}
		},
		// 从采购单导入
		handlePurchase(inputtype){
			this.modalProps = {
				show: true,
				title: this.$t('fbb.inbound.find_purchase_plan', { defaultValue: '查找采购计划' }),
				width: 1000,
				component: "compPurchase",
				showFooter: false,
				props: {
					inboundList: this.proinblundList,
                    poNosList: this.baseData.poNos,
                    inputtype:inputtype,
                    orderid:this.id,
				},
				on:{
                    'on-purchase':this.getpurchaseList,
                    'on-updatepro':this.onupdate
				}
			}
		},
		addItem(data) {
            // console.log(data)
			const { sku, qty } = data;
			if (sku && qty) {
				const erpSkuData = this.dataList.find((item) => {
					return item.sku === sku
				});
				if (erpSkuData) {
					erpSkuData.qty += qty;
				} else {
					this.dataList.push(data)
				}
				this.formData = { qty: '', sku: '' };
                this.getallVolumnWeight(this.dataList);
                // this.$emit('on-newdata',data)
                this.$emit('on-updateline',this.dataList[0])
				return;
			}
            this.$VMessage.warning(this.$t('fbb.inbound.fill_erpskuno', { defaultValue: '请填写ERPSKU和计划数量' }));
		},
		clearAll() {
			this.modalProps = {
				show: true,
				title: this.$tc('global.common.clear', 1, { defaultValue: '清空所有' }),
				alert: 'error',
				ajaxRequest: async () => {
                    this.dataList = [];
                    this.baseData.planQty = '';
                    this.proData.planQty = '';
                    this.baseData.totalVolume = '';
                    this.$set(this.proData,'totalVolume','')
                    this.baseData.totalWeight = '';
                    this.$set(this.proData,'totalWeight','')
					return { message: this.$t('global.common.haveto_empty', { defaultValue: '已清空' }) };
				}
			}
		},
		removeItems() {
			const checkedData = this.checkedData;
			if (!checkedData.length) {
				this.$VMessage.warning(this.$t('global.common.choose', { defaultValue: '请选择产品' }));
				return
			}
			this.modalProps = {
				show: true,
				title: this.$t('global.common.delete', { defaultValue: '删除' }),
				alert: 'warning',
				ajaxRequest: async () => {
					this.dataList = this.dataList.filter((row) => {
						return checkedData.indexOf(row.sku) == -1
                    })
                    this.getallVolumnWeight(this.dataList);
					return { message: this.$t('global.common.have_deleted', { defaultValue: '已删除' }) };
				}
			}

        },
		//生成箱标
		createPackageLabel() {
			this.modalProps = {
				show: true,
				title: this.$t('fbb.inbound.rawcrates_standard', { defaultValue: '生成箱标' }),
				alert: 'warning',
				showDesc: false,
				ajaxRequest: (parmas) => {
					return HttpCreatePackageLabel({ id: this.id, pageSize: parmas.index == 1 ? 1 : 6,type: parmas.type == 0 ? 1 : 2 ,isIndexNo:parmas.isIndexNo})
				},
				formdata: [
					{
						tag: 'vRadio',
						key: 'index',
						labelWidth: 'auto',
						default: '0',
						span: 24,
						label: this.$t('fbb.inbound.number_page', { defaultValue: '每页个数' }),
						options: [{
							trueValue: '0',
							label: this.$t('fbb.inbound.each_page', { pagevalue: '6', defaultValue: '每页6个' }),
						}, {
							trueValue: '1',
							label: this.$t('fbb.inbound.each_page', { pagevalue: '1', defaultValue: '每页1个' }),
						}]

					},
					{
						tag: 'vRadio',
						key: 'type',
						labelWidth: 'auto',
						default: '0',
						span: 24,
						label: this.$t('fbb.inbound.copies', { defaultValue: '份数' }),
						options: [{
							trueValue: '0',
							label: this.$t('fbb.inbound.cope_one', { defaultValue: '一式一份' }),
						}, {
							trueValue: '1',
							label: this.$t('fbb.inbound.cope_two', { defaultValue: '一式两份' }),
						}]

					},
					{
						tag: 'vCheckbox',
						key: 'isIndexNo',
						labelWidth: 'auto',
						required:false,
						default: '0',
						span: 24,
						label: this.$t('fbb.inbound.digital', { defaultValue: '是否生成序号' }),
						props: {
							trueValue: 1,
							falseValue: 0,
							strict: false,
						}
					}
				],
				callback: (res) => {
					this.modalProps = {};
                    this.operate = {
                        title: '生成箱标',
                        show: true,
                        width: 560,
                        component: "comExcel",
                        showFooter: false
                    };
					this.$VMessage.success(this.$t('fbb.inbound.async_task', { defaultValue: `异步任务【任务编号${res.data.taskNo}】已生成，请到任务中心查看处理进度及结果！`, taskNo: res.data.taskNo }));
				}
			}
		},
		// 下载箱标
		downloadPackageLabel() {
			this.handleWebfs(HttpDownloadPackageLabel, { inboundPlanOrderId: this.id }, { executor: 'request', download: true });
		},
        onupdate(){
            this.$emit('on-updatelist')
        }

	}
}
</script>
